import { render } from "./ProfileFollows.vue?vue&type=template&id=77f3cbf9&scoped=true"
import script from "./ProfileFollows.vue?vue&type=script&lang=js"
export * from "./ProfileFollows.vue?vue&type=script&lang=js"

import "./ProfileFollows.vue?vue&type=style&index=0&id=77f3cbf9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f3cbf9"]])

export default __exports__